import React, { useState } from 'react';
import Swal from 'sweetalert2';
import Fetch from 'utils/fetch';
import { settings } from 'settings';

export function setUpdateButtonColorByStatus(
  nrOfParcels,
  newNrOfParcels,
  parcelCounted
) {
  if (nrOfParcels === newNrOfParcels) {
    return 'grey';
  } else if (newNrOfParcels === parcelCounted) {
    return '#0eb227';
  } else if (newNrOfParcels < parcelCounted && newNrOfParcels > 0) {
    return '#ffe200';
  } else if (newNrOfParcels === 0) {
    return '#dd4912';
  } else {
    return '#FF8AFE';
  }
}

async function updatePackagesNumber(orderId: string, packagesNumber: number) {
  try {
    const response = await Fetch.put({
      url: `${settings.newApiUrl}/order/${orderId}/set-package-number/${packagesNumber}`,

      body: {},
    });

    if (response.ok) {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Nr of parcels is updated',
        showConfirmButton: false,
        timer: 1500,
      });
      return true;
    }
  } catch (error) {
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'There was an error, try again',
      showConfirmButton: false,
      timer: 1500,
    });
    return false;
  }
}

async function updatePackagesNumberInOrder(
  orderId: string,
  newNrOfParcels: number,
  callback: (bundleId: string[]) => void,
  bundleId: string
) {
  Swal.fire({
    title: 'Danger zone!',
    text: `Are you sure you want to update orderId ${orderId} to have ${newNrOfParcels} parcels?.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Update Parcels',
    confirmButtonColor: '#0eb227',
    cancelButtonColor: '#ccc',
  })
    .then(async result => {
      if (result.value) {
        const booleanReturn = await updatePackagesNumber(
          orderId,
          newNrOfParcels
        );
        if (booleanReturn) {
          callback([bundleId]);
        }
      } else {
        Swal.fire('The bundle is safe!');
      }
    })
    .catch(error => console.error(error.message));
}

const buttonStyle = {
  backgroundColor: 'black',
  color: 'white',
  fontSize: '1.4rem',
  margin: '6px 2px',
  cursor: 'pointer',
  outline: 'none',
};

export function UpdateKolliButton({
  nrOfParcels,
  parcelCounted,
  orderId,
  updateHubSortListEntries,
  bundleId,
}) {
  const [newNrOfParcels, setNewNrOfParcels] = useState(nrOfParcels);

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
        }}
      >
        <button
          onClick={() => setNewNrOfParcels(newNrOfParcels - 1)}
          disabled={newNrOfParcels === 1}
          style={buttonStyle}
        >
          -
        </button>
        <button
          onClick={() =>
            updatePackagesNumberInOrder(
              orderId,
              newNrOfParcels,
              updateHubSortListEntries,
              bundleId
            )
          }
          className="btn btn-porter"
          disabled={newNrOfParcels === nrOfParcels}
          style={{
            paddingLeft: '5px',
            paddingRight: '5px',
            border: '0.5px solid black',
            backgroundColor: setUpdateButtonColorByStatus(
              nrOfParcels,
              newNrOfParcels,
              parcelCounted
            ),
          }}
        >
          Update to {newNrOfParcels}
        </button>
        {/*<span>{newNrOfParcels}</span>*/}
        <button
          onClick={() => setNewNrOfParcels(newNrOfParcels + 1)}
          style={buttonStyle}
        >
          +
        </button>
      </div>
    </>
  );
}
